export enum WindSpeedUnit {
    MPH, KMH, KNOTS, MPS, BFT
}